import { Box, styled } from '@mui/material';

export const NoOptionsWrapper = styled(Box)(({ theme }) => ({
  padding: `${theme.spacing(0.5)} ${theme.spacing(1)}`,
  cursor: 'pointer',
}));
